import React from "react";
import { MdLocalShipping } from "react-icons/md";
import { runChipText } from "./runs";

/**
 * An order's run, next to its route in the Shipping cell ("Run Wed Oct 28 ·
 * stop 3/12"). `stop` is the order's open_run_stop; clicking opens the run.
 */
const RunChip = ({ stop, onOpen }) =>
  stop?.run_id ? (
    <button
      type="button"
      title="Open this run"
      onClick={(event) => {
        event.stopPropagation();
        onOpen(stop.run_id);
      }}
      className="flex min-w-[0px] shrink items-center gap-[4px] whitespace-nowrap rounded-full border-[1px] border-state-info-border bg-state-info-bg px-[7px] py-[1px] text-[11px] font-semibold text-state-info-text hover:brightness-95"
    >
      <MdLocalShipping
        aria-hidden="true"
        className="h-[12px] w-[12px] shrink-0"
      />
      <span className="truncate">{runChipText(stop)}</span>
    </button>
  ) : null;

export default RunChip;
